
import { useContactForm } from "./hooks/useContactForm";
import BasicInfoFields from "./BasicInfoFields";
import ContactFormBusinessType from "./ContactFormBusinessType";
import ContactFormPlanningService from "./ContactFormPlanningService";
import MessageField from "./MessageField";
import SubmitButton from "./SubmitButton";
import PrivacyNotice from "./PrivacyNotice";

const ContactSectionForm = () => {
  const { formData, isSubmitting, errors, handleChange, handleSubmit } = useContactForm();

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid md:grid-cols-2 gap-6 mb-6">
        <BasicInfoFields formData={formData} onChange={handleChange} errors={errors} />
        
        <div className="md:col-span-2">
          <ContactFormBusinessType
            value={formData.businessType}
            onChange={handleChange}
          />
        </div>
        
        <div className="md:col-span-2">
          <ContactFormPlanningService
            checked={formData.planningService}
            onChange={handleChange}
          />
        </div>
      </div>
      
      <MessageField value={formData.message} onChange={handleChange} />
      
      <SubmitButton isSubmitting={isSubmitting} />
      
      <PrivacyNotice />
    </form>
  );
};

export default ContactSectionForm;
